import service from '@/services/superaccess'

const network = {
  state: {
    network_modal: false
  },
  mutations: {
    updateStatusNetworkModal (state, status) {
      state.network_modal = status
    }
  },
  getters: {
    getStatusNetworkModal (context) {
      return context.network_modal
    }
  },
  actions: {
    setStatusNetworkModal (context, payload) {
      context.commit('updateStatusNetworkModal', payload)
    },
    retrieveNetworks (context, payload) {
      return service.get('/api/networks', context)
    },
    registerNetworks (context, payload) {
      return service.post('/api/networks/register', context, { networks: payload })
    },
    rewriteNetworks (context, payload) {
      return service.get('/api/networks/rewrite', context)
    },
    changeNetworkStatus (context, payload) {
      return service.patch('/api/network/inactive', context, payload)
    },
    modifyNetwork (context, payload) {
      return service.patch('/api/network/modify', context, { network: payload })
    }
  }
}

export default network



// WEBPACK FOOTER //
// app/javascript/src/store/network.js